<p-dialog [blockScroll]="true" (onHide)="hideModal()" [header]="'Send Alert'|translator" [draggable]="false"
    header="Header" [(visible)]="visible" [style]="{ width: '60%' }">
    <textarea [placeholder]="'Alert Message'|translator" pInputTextarea [(ngModel)]="message" rows="10"
        style="width: 100%;">
    </textarea>
    <ng-template pTemplate="footer">
        <p-button [disabled]="!(!!this.trainingId && !!this.message)" [label]="'send' | translator" icon="pi pi-send"
            (onClick)="sendAlert()"></p-button>
    </ng-template>
</p-dialog>